import { createContext } from 'react';

interface SubCategoryContextProps<T> {
    value: T;
    setValue: (v: T) =>void;
    isColorful?: boolean;
}

const SubCategoryContext = createContext<SubCategoryContextProps<any>>({
    value: '', setValue: () => {},
});

export default SubCategoryContext;
